import {
	fetchTasks,
	fetchTask,
	fetchClassifications,
	markTaskAsComplete as completeTask,
} from './api'

const getTasks = async({ commit }, payload) => {
	const { page, pageSize, query, classification } = payload
	
	let tasks = []
	
	try {
		tasks = (await fetchTasks({
			query,
			classification,
			pageSize,
			page,
		})).data.data
		
		if(page > 1) {
			tasks = state.tasks.concat(tasks)
		}
		
		commit('SET_TASKS', tasks)
		commit('SET_CLASSIFICATIONS', tasks)
		
		return tasks
	} catch(e) {
		console.error(e)
	}
}

const getTask = async({ commit }, params) => {
	try {
		const response = (await fetchTask(params)).data.data
		
		commit('SET_TASK', response.task)
		
		return response
	}
	catch(e) {
		console.error(e)
	}
}

const getClassifications = async() => {
	try {
		return (await fetchClassifications()).data.data
	}
	catch(e) {
		console.error(e)
	}
}

const markTaskAsComplete = async({ commit }, payload) => {
	try {
		return await completeTask(payload)
	} catch (e) {
		console.error(e)
	}
}

export default {
	getTasks,
	getTask,
	getClassifications,
	markTaskAsComplete,
}
